<template>
<w-frame-popup-content-template>
  <div slot="content">
    <el-form v-loading="loading" v-show="changeFormFlag" label-position="top" :model="accountFormDatas" :rules="rules" ref="userAccountForm">
      <!-- 계정 정보 -->
      <div class="title-bar title-h4">계정 정보</div>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="아이디" prop="managerId">
            <el-input v-model="accountFormDatas.managerId" readonly disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="이름" prop="managerName">
            <el-input v-model="accountFormDatas.managerName"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="역할" prop="managerType">
            <el-input v-model="accountFormDatas.managerTypeLabel" readonly disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="비밀번호" prop="password">
            <el-button style="100%" size="mini" type="primary" @click="changeFormFlag = false">비밀번호 변경하기</el-button>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="mr-b25" :gutter="20">
        <el-col :span="12">
          <el-form-item label="비밀번호 찾기 질문" prop="passwordLostQuestion">
            <el-select style="width:100%;" v-model="accountFormDatas.passwordLostQuestion" placeholder="선택">
              <el-option v-for="item in passwordLostQuestionOptions" :key="item.basicinfoSubid" :label="item.basicinfoSubname" :value="item.basicinfoSubid"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="비밀번호 찾기 답변" prop="passwordLostAnswer">
            <el-input v-model="accountFormDatas.passwordLostAnswer"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 기본정보 -->
      <div class="title-bar title-h4">기본 정보</div>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="소속" prop="association">
            <el-input v-model="accountFormDatas.association"></el-input>
          </el-form-item>
          <el-form-item label="직급" prop="grade">
            <el-input v-model="accountFormDatas.grade"></el-input>
          </el-form-item>
          <el-form-item label="모바일" prop="mobileNumber">
            <el-input v-model="accountFormDatas.mobileNumber" placeholder="000-1111-2222, 00011112222"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="부서" prop="department">
            <el-input v-model="accountFormDatas.department"></el-input>
          </el-form-item>
          <el-form-item label="사번" prop="empno">
            <el-input v-model="accountFormDatas.empno"></el-input>
          </el-form-item>
          <el-form-item label="내선번호" prop="telNumber">
            <el-input v-model="accountFormDatas.telNumber"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <div style="border: 1px solid #d1d2d3;height: 138px;">
            <img width="100%" height="100%" :src="imageUrl" alt="">
          </div>
          <el-form-item style="margin-top:6px; width: 100%;" prop="managerPhoto">
            <el-upload :file-list="fileInfo" :show-file-list="false" :before-upload="(file) => file" action="" :on-change="changeUploadFile" :auto-upload="false" height="20%" style="width:100%;" class="full-upload">
              <el-button style="width:100%" type="secondary" size="mini">파일 업로드</el-button>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="E-Mail" prop="email">
        <el-input v-model="accountFormDatas.email" placeholder="address@watchtek.co.kr"></el-input>
      </el-form-item>
      <!-- 접근 IP 설정 -->
      <div class="mr-t25">
        <div class="title-bar title-h4">접근 허용 IP 설정</div>
        <el-form-item class="veritcal-center-box" prop="addAccessAllowIp">
          <div style="width: 30px; margin-top: 5px; float: left">
            <label class="mr-r15">IP</label></div>
          <div style="width: 260px; margin:1px 3px 0 0; float: left">
            <el-input style="top:-1px;width:260px;" v-model="addAccessAllowIp" @keyup.native.enter="onAddAccessAllowIp" placeholder="입력해 주세요."></el-input>
          </div>
          <div style="width: 50px; float:left">
            <el-button size="mini" @click="onAddAccessAllowIp" type="primary">추가</el-button>
          </div>
        </el-form-item>
        <el-table-wrapper :data="accessAllowIps" :columns="columns" :column-default="columnDefault " :pagination="false">
          <template slot-scope="scope" slot="remove-slot">
          <i class="fal fa-times c-pointer" @click="onClickDeleteAccessAllowIp(scope)"></i>
        </template>
        </el-table-wrapper>
      </div>
    </el-form>
    <!-- 비밀번호 변경 -->
    <!-- ChangePassword.vue 와 통일성 유지 필요 -->
    <el-form v-show="!changeFormFlag" label-position="top" :model="passwordFormDatas" :rules="rules2" ref="userPasswordForm">
      <div class="goback-small c-pointer l-align">
        <i class="fal fa-arrow-left" @click="onClickCancel"></i> 비밀번호 변경
      </div>
      <div class="mr-b15">
        <el-form-item label="현재 비밀번호" prop="password">
          <el-input type="password" v-model="passwordFormDatas.password"></el-input>
        </el-form-item>
      </div>
      <div class="mr-b15">
        <el-form-item label="새 비밀번호" prop="modifyPassword">
          <el-input type="password" v-model="passwordFormDatas.modifyPassword"></el-input>
        </el-form-item>
      </div>
      <el-form-item label="변경된 비밀번호 확인" prop="checkPassword">
        <el-input type="password" v-model="passwordFormDatas.checkPassword" @keyup.native.enter="onClickUpdateUserAccount"></el-input>
      </el-form-item>
    </el-form>
  </div>
  <el-row slot="footer" type="flex" justify="center">
    <el-button type="solid" class="mr-r4" size="large" @click="onClickUpdateUserAccount">저장</el-button>
    <el-button size="large" @click="onClickCancel">취소</el-button>
  </el-row>
</w-frame-popup-content-template>
</template>

<script>
import { isEqual, isNil, isEmpty, cloneDeep, join } from 'lodash';
import userAPI from '@/api/frame/user';
import loginAPI from '@/api/login';
import store from '@/store';
import msgUtil from '@/utils/message';
import { validatePassword, validateIpv4, validateIpv6, validateEmailAddr } from '@/utils/string';
import { isUnauthorizedFile, isImageFile } from '@/utils/file';
import { MSG_UPLOAD_UNAUTHORIZED_FILE, MSG_UPLOAD_IMAGE_ONLY } from '@/constants/file';
import { columnDefault } from '@/constants/table';
import UserSettingAPI from '@/api/settings/user/user-setting';
import BasicinfoSubAPI from '@/api/model/basicinfo-sub';
import rsaEncrypt from '@/utils/rsa-encrypt';
import WFramePopupContentTemplate from './FramePopupContentTemplate';

export default {
  name: 'WAccountInfoForm',
  components: {
    WFramePopupContentTemplate,
  },
  props: {
    closeFlag: {
      type: Boolean,
    },
  },
  data() {
    return {
      columnDefault,
      loading: false,
      accountFormDatas: {
        managerId: '',
        managerName: '',
        association: '',
        department: '',
        grade: '',
        empno: '',
        mobileNumber: '',
        telNumber: '',
        email: '',
        accessAllowIp: '',
        passwordLostAnswer: '',
        passwordLostQuestion: '',
        managerType: '',
        managerPhoto: '',
      },
      initFormDatas: {},
      passwordFormDatas: {
        password: '',
        modifyPassword: '',
        checkPassword: '',
      },
      changeFormFlag: true,
      imageUrl: '',
      fileInfo: [],
      file: {},
      passwordLostQuestionOptions: [],
      columns: [
        {
          prop: 'ipaddress',
          label: '접근 허용 IP',
        },
        {
          scopedSlot: 'remove-slot',
          width: 50,
        },
      ],
      accessAllowIps: [],
      addAccessAllowIp: '',
      policyObject: {
        PASSWORDCHANGINGTYPE: 'PASSWORDINIT',
      },
      rules: {
        managerId: {
          required: true,
          trigger: 'blur',
        },
        managerName: {
          required: true,
          message: '필수 정보입니다.',
          trigger: 'blur',
        },
        email: {
          validator: this.validateEmailAddress,
          message: '이메일 형식이 올바르지 않습니다.',
          trigger: 'blur',
        },
      },
      rules2: {
        password: {
          required: true,
          validator: this.validateCurrentPassword,
          trigger: 'blur',
        },
        modifyPassword: {
          required: true,
          validator: this.validatePassword,
          trigger: 'blur',
        },
        checkPassword: {
          required: true,
          validator: this.validateNewPasswordConfirm,
          trigger: 'blur',
        },
      },
    };
  },
  watch: {
    closeFlag: {
      handler(val) {
        if (val === true) {
          this.loadStore();
        } else {
          this.reset();
        }
      },
    },
  },
  created() {
    this.loadStore();
  },
  // beforeCreate() {
  //
  // },
  methods: {
    // store load
    loadStore() {
      this.clearFormData();
      BasicinfoSubAPI.getList('sdpwq')
        .then((response) => {
          if (response.data.success) {
            this.passwordLostQuestionOptions = response.data.data;
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '기준 정보', false));
          }
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '기준 정보', false));
        });

      UserSettingAPI.getAllAccountPolicyList()
        .then((response) => {
          if (response.data.success) {
            if (!isNil(response.data.data)) {
              response.data.data.forEach((item) => {
                const policyType = item.basicinfoSubid;
                const dataType = item.datatypeId;
                if (isEqual(dataType, 'STRING')) {
                  this.policyObject[policyType] = item.basicinfoSubvalueString;
                } else if (isEqual(dataType, 'BOOL')) {
                  this.policyObject[policyType] = Number(item.basicinfoSubvalueBoolean);
                  if (isEqual(policyType, 'SECURITYWEAKPATTERNCHECK')) {
                    this.policyObject.PATTERN = item.basicinfoSubvalueString;
                  }
                } else if (isEqual(dataType, 'INTEGER')) {
                  this.policyObject[policyType] = item.basicinfoSubvalueInteger;
                }
              });
            }
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '계정 보안 정책 정보', false));
          }
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '계정 보안 정책 정보', false));
        });

      this.loading = true;
      userAPI
        .getUserAccountList()
        .then((result) => {
          if (result.data.success === true) {
            const data = result.data.data;
            this.setData(data);
            this.initFormDatas = cloneDeep(data);
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '사용자 정보', false));
          }
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '사용자 정보', false));
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * 폼을 초기화한다.
     * @author Ju
     */
    reset() {
      this.$refs.userPasswordForm.resetFields();
      this.$refs.userAccountForm.resetFields();
    },
    /**
     * [setData 데이터 셋팅]
     * @author {Yang}
     */
    setData(data) {
      this.accountFormDatas = {};
      this.accountFormDatas = cloneDeep(data);
      if (!isEmpty(this.accountFormDatas.accessAllowIp)) {
        this.accessAllowIps = [];
        const accessAllowIp = this.accountFormDatas.accessAllowIp.split(',');
        accessAllowIp.forEach((item) => {
          this.accessAllowIps.push({
            ipaddress: item,
          });
        });
      }
      if (!isEmpty(this.accountFormDatas.managerPhoto)) {
        const photo = this.accountFormDatas.managerPhoto;
        this.imageUrl = `data:${photo.headers['Content-Type'][0]} ;base64, ${photo.body}`;
      } else {
        this.imageUrl = '';
      }
    },
    /**
     * [onClickCancel 취소버튼 클릭시]
     * @author {Yang}
     */
    onClickCancel() {
      this.cleanPassword();
      if (this.changeFormFlag === false) {
        this.changeFormFlag = true;
      } else {
        this.$emit('onCancelPopup');
      }
    },
    cleanPassword() {
      this.passwordFormDatas.password = '';
      this.passwordFormDatas.modifyPassword = '';
      this.passwordFormDatas.checkPassword = '';
      this.file = {};
    },
    changeUploadFile(file) {
      // 비인가 확장자 파일인 경우 업로드 불가능
      if (isUnauthorizedFile(file)) {
        this.$message(msgUtil.getCustomResultMsgData(MSG_UPLOAD_UNAUTHORIZED_FILE, false));
        return;
      }
      // 이미지 확장자 파일인 경우에만 업로드
      if (!isImageFile(file)) {
        this.$message(msgUtil.getCustomResultMsgData(MSG_UPLOAD_IMAGE_ONLY, false));
      } else {
        this.imageUrl = URL.createObjectURL(file.raw);
        this.$set(this.file, 'fileInfo', file.raw);
      }
    },
    /**
     * [onAddAccessAllowIp 접근IP 추가]
     * @author {Yang}
     */
    onAddAccessAllowIp() {
      this.validateIpaddress();
    },
    /**
     * [onClickDeleteAccessAllowIp 접근 ip 삭제]
     * @author {Yang}
     */
    onClickDeleteAccessAllowIp(row) {
      this.accessAllowIps.splice(row.$index, 1);
    },
    /**
     * [onClickUpdateUserAccount 저장버튼]
     * @author {Yang}
     * @return {[type]} [description]
     */
    onClickUpdateUserAccount() {
      if (this.changeFormFlag) {
        this.$refs.userAccountForm.validate((valid) => {
          if (valid) {
            this.updateUserAccountInfo();
            return true;
          }
          return false;
        });
      } else {
        this.$refs.userPasswordForm.validate((valid) => {
          if (valid) {
            this.updateUserPasswordInfo();
            return true;
          }
          return false;
        });
      }
    },
    /**
     * [updateUserAccountInfo mgr 수정]
     * @author {Yang}
     * @return {[type]} [description]
     */
    updateUserAccountInfo() {
      const fileData = this.file.fileInfo;
      this.accountFormDatas.accessAllowIp = '';
      if (!isEmpty(this.accessAllowIps)) {
        const saveAccessAllowIps = [];
        this.accessAllowIps.forEach((item) => {
          saveAccessAllowIps.push(item.ipaddress);
        });
        this.accountFormDatas.accessAllowIp = join(saveAccessAllowIps, ',');
      }
      const formParams = new FormData();
      if (!isNil(fileData)) {
        formParams.append('file', fileData);
      }
      formParams.append('managerName', this.isCheckValue(this.accountFormDatas.managerName));
      formParams.append('association', this.isCheckValue(this.accountFormDatas.association));
      formParams.append('department', this.isCheckValue(this.accountFormDatas.department));
      formParams.append('grade', this.isCheckValue(this.accountFormDatas.grade));
      formParams.append('empno', this.isCheckValue(this.accountFormDatas.empno));
      formParams.append('mobileNumber', this.isCheckValue(this.accountFormDatas.mobileNumber));
      formParams.append('telNumber', this.isCheckValue(this.accountFormDatas.telNumber));
      formParams.append('email', this.isCheckValue(this.accountFormDatas.email));
      formParams.append('accessAllowIp', this.isCheckValue(this.accountFormDatas.accessAllowIp));
      formParams.append('passwordLostQuestion', this.isCheckValue(this.accountFormDatas.passwordLostQuestion));
      formParams.append('passwordLostAnswer', this.isCheckValue(this.accountFormDatas.passwordLostAnswer));

      const action = msgUtil.action.MODIFY;
      const target = '사용자';
      userAPI
        .updateUserAccountInfo(formParams)
        .then((result) => {
          if (result.data.success === true) {
            this.$message(msgUtil.getResultMsgData(action, target, true));
            this.reloadUserInfoStore();
            this.onClickCancel();
          } else {
            this.$message(msgUtil.getCustomResultMsgData(result.data.message, false));
          }
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        });
    },
    /**
     * [updateUserPasswordInfo 비밀번호 수정]
     * @author {Yang}
     * @return {[type]} [description]
     */
    updateUserPasswordInfo() {
      const fieldData = {
        managerId: this.accountFormDatas.managerId,
        password: this.passwordFormDatas.modifyPassword,
      };
      rsaEncrypt.getRsaEncrypt(fieldData).then((encryData) => {
        const params = {
          managerId: encryData.managerId,
          password: encryData.password,
        };
        UserSettingAPI.changePassword(params).then(() => {
          this.$message('비밀번호가 변경되었습니다.');
          this.reloadUserInfoStore();
          this.onClickCancel();
          this.loadStore();
        });
      });
    },
    /**
     * [reloadUserInfo userInfo 리로드 한다.]
     * @author {Yang}
     */
    reloadUserInfoStore() {
      loginAPI.checkLogin().then((response) => {
        const result = response.data;
        if (!isEmpty(result) && result.success === true && !isEmpty(result.data)) {
          const data = response.data.data;
          store.dispatch('setUserInfo', data.userInfo);
          store.dispatch('setRoles', data.roles);
        }
      });
    },
    clearFormData() {
      if (this.changeFormFlag === false) {
        this.changeFormFlag = true;
      }
      this.cleanPassword();
      this.accountFormDatas = {
        managerId: '',
        managerName: '',
        association: '',
        department: '',
        grade: '',
        empno: '',
        mobileNumber: '',
        telNumber: '',
        email: '',
        accessAllowIp: '',
        passwordLostAnswer: '',
        passwordLostQuestion: '',
        managerType: '',
        managerPhoto: '',
      };
      this.addAccessAllowIp = '';
      this.accessAllowIps = [];
    },
    isCheckValue(value) {
      return isNil(value) ? '' : value;
    },
    /**
     * 이메일 주소 유효성 검사
     * 2개 이상의 이메일 주소가 작성될 수 있도록 수정
     * @param  {[type]}   rule     [description]
     * @param  {[type]}   value    [description]
     * @param  {Function} callback [description]
     * @return {[type]}            [description]
     */
    validateEmailAddress(rule, value, callback) {
      if (isNil(value) || value === '') {
        callback();
      } else {
        const emailArr = value.split(',');
        let isValid = true;
        emailArr.forEach((item) => {
          const replaceText = item;
          const validTest = validateEmailAddr(replaceText.replace(/^\s*/, ''), '');
          if (!validTest) {
            isValid = false;
          }
        });
        if (isValid) {
          callback();
        } else {
          callback(new Error('이메일 주소 형식을 확인해주세요.'));
        }
      }
    },
    /**
     * 현재 비밀번호 유효성 검사
     * @param  {[type]}   rule     [description]
     * @param  {[type]}   value    [description]
     * @param  {Function} callback [description]
     * @return {[type]}            [description]
     */
    validateCurrentPassword(rule, value, callback) {
      if (isNil(value) || isEqual(value.length, 0)) {
        callback(new Error('비밀번호를 입력해주세요.'));
      } else {
        const fieldInfo = {
          password: this.passwordFormDatas.password,
        };
        rsaEncrypt.getRsaEncrypt(fieldInfo).then((encryData) => {
          const params = {
            password: encryData.password,
          };
          UserSettingAPI.checkAdminPassword(params).then((response) => {
            if (response.data.data) {
              callback();
            } else {
              callback(new Error('비밀번호가 맞지 않습니다.'));
            }
          });
        });
      }
    },
    /**
     * 패스워드 정책에 맞는 유효성검사를 한다.
     * @param  {[type]}   rule     [description]
     * @param  {[type]}   value    [description]
     * @param  {Function} callback [description]
     * @return {[type]}            [description]
     * @author jda
     */
    validatePassword(rule, value, callback) {
      const result = validatePassword(value, this.policyObject, this.accountFormDatas);
      if (result.valid) {
        callback();
      } else {
        callback(new Error(result.message));
      }
    },
    /**
     * 변경된 비밀번호와 동일한지 유효성 검사
     * @param  {[type]}   rule     [description]
     * @param  {[type]}   value    [description]
     * @param  {Function} callback [description]
     * @return {[type]}            [description]
     */
    validateNewPasswordConfirm(rule, value, callback) {
      if (isNil(value) || value.length <= 0) {
        callback(new Error('비밀번호를 입력해주세요.'));
      } else {
        const password = this.passwordFormDatas.modifyPassword;
        if (isNil(password) || password.length <= 0) {
          callback(new Error('비밀번호를 입력해주세요.'));
        }
        if (!isEqual(value, password)) {
          callback(new Error('비밀번호가 일치하지 않습니다.'));
        }
      }
      callback();
    },
    /**
     * [validateIpaddress IP 유효성 검사]
     * @author {Yang}
     */
    validateIpaddress() {
      const value = this.addAccessAllowIp;
      if (isNil(value)) {
        this.$message(msgUtil.getCustomMsgData('IP를 입력해주세요.'));
      } else if (validateIpv4(value) || validateIpv6(value)) {
        this.accessAllowIps.push({
          ipaddress: value,
        });
        this.addAccessAllowIp = '';
      } else {
        this.$message(msgUtil.getCustomMsgData('올바른 주소형식을 입력해주세요.'));
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/frame/components/popup/AccountInfoForm.vue